export const ROUTE_PATH = {
    PUBLIC: {
        LOGIN: '/login',
        PASSWORD: {
            FORGOT: '/password/forgot',
            RESET: '/password/reset',
        },
        CONFIRM: {
            CREATE_USER: '/registration/user/complete'
        },
        PROSPECT: {
            CONFIRM: '/prospect/confirm'
        }
    },

    CLIENT: {
        _SELF: '/client',
        CONNECT: '/client/connect',
        JOIN: '/client/join',
        JOIN_WITH_CODE: '/client/join/:code/:pin',
        // TODO: can we change it to /client/<path> ?
        START_PAGE: '/client-start-page',
        CONFERENCE: {
            _SELF: '/client/conference',
            ANDROID_SDK_OLD: '/client/conference/android-sdk',
            IOS_SDK_OLD: '/client/conference/ios-sdk',
            ANDROID_SDK: '/client/conference/sdk/android',
            IOS_SDK: '/client/conference/sdk/ios',
            WEB: '/client/conference/web',
            WEB_CONVERSATION_ONLY: '/client/conference/web/conversation-only',
        },
    },

    GUEST: {
        JOIN: '/guest/join',
        JOIN_WITH_CODE: '/guest/join/:code/:pin',
        CONFERENCE: {
            _SELF: '/guest/conference',
        }
    },

    USER: {
        ONLINE: {
            _SELF: '/online',
            SESSIONS: '/online/sessions',
            CONVERSATIONS: '/online/conversations',
        },
        ACCOUNT_ACTIVATION: {
            _SELF: '/account-activation'
        },
        ACCOUNT_BLOCKED: {
            _SELF: '/account-blocked'
        },
        ACTIVITY: {
            _SELF: '/activity',
            SESSION_HISTORY: '/activity/session-history',
            PRE_SESSION_FLOW: '/activity/pre-session-flow',
            DASHBOARD: '/activity/dashboard',
            AGENTS_STATISTIC: '/activity/agents-statistic',
            COMPLIANCE: '/activity/compliance'
        },
        ACCOUNT: {
            _SELF: '/account',
            MY_PROFILE: '/account/users/me',
            SETTINGS: '/account/settings',
            CREATE_USER: '/account/users/create',
            EDIT_USER: '/account/users/:eid/edit',
            USERS: '/account/users',
            INTEGRATIONS: '/account/integrations',
            ROLES: '/account/roles',
            OUTGOING_MESSAGES: '/account/outgoing-messages',
            WORKING_HOURS: '/account/working-hours',
            CLIENTS_CONNECTS: '/account/clients-connects',
            LIVE_HELP: '/account/live-help',
            SESSION: '/account/session',
            GROUPS: '/account/groups',
            BILLING: '/account/billing',
            APPOINTMENTS: '/account/appointments',
        },
        CONTENT: {
            _SELF: '/content',
            SESSION_RESULT: '/content/session-result',
            CLIENT_SESSION: '/content/client-session',
        },
        CONFERENCE: {
            _SELF: '/conference',
            ASSISTANT: '/conference/assistant/:sessionId'
        },
        ERROR: {
            SERVER_CONNECTION: '/error/server-connection'
        },
        PASSWORD: {
            EXPIRED: '/password/expired'
        },
        ABOUT: {
            ME: '/about/me'
        }
    },
    SESSION: {
        JOIN: {
            _SELF: '/session/join/:role/:sessionId',
            AGENT: '/session/join/agent/:sessionId',
            AGENT_INTEGRATION: '/session/join/agent/:sessionId/integration',
            ASSISTANT: '/session/join/assistant/:sessionId',
        },
        FILE_REDIRECT: '/s/:sessionId/f/:fileParams/r', // s - session, f - file, r - redirect
    },
    TEST: {
        _SELF: '/test',
        TWILIO_VIDEO: '/test/video/twilio',
        KURENTO_VIDEO: '/test/video/internal'
    },
};

export const NO_AUTH_ROUTE_PATHS = [
    ROUTE_PATH.PUBLIC.LOGIN,
    ROUTE_PATH.PUBLIC.PASSWORD.FORGOT,
    ROUTE_PATH.PUBLIC.PASSWORD.RESET,
    ROUTE_PATH.PUBLIC.CONFIRM.CREATE_USER,
    ROUTE_PATH.PUBLIC.PROSPECT.CONFIRM
];

export enum ParentRoutes {
    Online = 'online',
    AccountActivation = 'accountActivation',
    AccountBlocked = 'accountBlocked',
    Activity = 'activity',
    Account = 'account',
    Content = 'content'
}
